import { useEffect, useRef } from 'react';

/**
 * Hook that converts values to refs to ensure callbacks always access the latest values
 * @param values Object containing values to convert to refs
 * @returns Object with the same structure but all values are refs
 */
export function useLatestValuesRef<T extends Record<string, unknown>>(values: T) {
  const latestValues = useRef<T>(values);

  // Update ref whenever values change
  useEffect(() => {
    latestValues.current = values;
  }, [values]);

  return latestValues;
}
